module.exports = __webpack_public_path__ + "static/amigos-background-white-ebddd7cab301ffe8e57bf44e6997c7f7.svg";